module.exports = __webpack_public_path__ + "static/media/Muli-VariableFont:wght.e8efee92.ttf";